document.addEventListener("DOMContentLoaded", (() => {
	const buttons = document.querySelectorAll(".dpd-collapse");

	for (const button of buttons) {
		const block = button.closest(".wp-block-buttons");
		if (block && block.nextElementSibling.classList.contains("wp-block-group")) {
			const group = block.nextElementSibling;
			//group.style.maxHeight ? group.style.maxHeight = null : group.style.maxHeight = group.scrollHeight + "px";
			group.style.transition = "max-height 1s ease";
			button.addEventListener('click', () => {
				button.classList.toggle("active");
				group.style.maxHeight ? group.style.maxHeight = null : group.style.maxHeight = group.scrollHeight + "px"
				//if (button.classList.contains("active")) {
					//button.classList.remove("active");
					
				//}
			});
		}
	   
		
	  }
	}
));
